import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { Paper } from "@mui/material";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const Lmap = ({ selectedPosition, setSelectedPosition }) => {
  const markerPos1 = selectedPosition;
  //   const [selectedPosition, setSelectedPosition] = useState([0, 0]);

  const Markers = () => {
    // const map = useMapEvents({
    //   click(e) {
    //     setSelectedPosition([e.latlng.lat, e.latlng.lng]);
    //     console.log({ e });

    //   },
    // });

    const map1 = useMap();

    useEffect(() => {
      map1.setView(selectedPosition, 15);
    }, selectedPosition);

    return selectedPosition ? (
      <Marker
        key={selectedPosition[0]}
        position={selectedPosition}
        interactive={false}
      />
    ) : null;
  };

  const onHandleClickMap = (ev) => {
    console.log({ ev });
  };

  const displayMap = (
    <Paper elevation={3}>
      <MapContainer
        center={markerPos1}
        scrollWheelZoom={true}
        zoom={10}
        style={{
          width: "100%",
          height: "300px",
        }}
        onClick={onHandleClickMap}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Markers />
      </MapContainer>
    </Paper>
  );

  return <div>{displayMap}</div>;
};

export default Lmap;
